import './cards.svg';



// WEBPACK FOOTER //
// app/javascript/common/images/index.js